<template>
  <div>
    <div class="border-ontick-steel-300 dark:border-ontick-graphite-500 overflow-y-auto rounded-lg border-b shadow">
      <table class="divide-ontick-steel-300 dark:divide-ontick-carbon-500 min-w-full table-fixed divide-y">
        <thead class="bg-ontick-steel-200 dark:bg-ontick-steel-500">
          <tr>
            <th></th>
            <th
              v-for="(item, index) in list_months"
              :key="index"
              scope="col"
              class="text-ontick-carbon-900 px-3 py-3 text-center text-xs font-medium uppercase tracking-wider dark:text-gray-300"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody
          class="divide-ontick-steel-300 dark:divide-ontick-carbon-500 dark:bg-ontick-graphite-500 divide-y bg-gray-50 text-center"
        >
          <template v-if="pnlError != ''">
            <tr>
              <td class="p-4" colspan="14">
                <span>{{ pnlError }}</span>
              </td>
            </tr>
          </template>
          <template v-if="pnlError === '' && months.length > 0">
            <tr v-for="(item, index) in months" :key="index">
              <td
                :class="[hasBorder(year[index], 'ALL') && 'border-ontick-blue-600 border-2']"
                class="text-ontick-carbon-900 px-3 text-xs font-medium hover:cursor-pointer dark:text-gray-300"
                @click="setPeriod({ year: year[index], month: 'ALL' })"
              >
                <span>{{ year[index] }}</span>
              </td>
              <td
                v-for="(item2, index2) in item"
                :key="index2"
                :class="[
                  statusColor(typeof item2 === 'object' ? item2.result : item2, {
                    year: year[index],
                    month: list_months[index2].toString().toUpperCase(),
                  }),
                  // item2 == 0 || list_months[index2] == 'Anual'
                  //   ? 'cursor-not-allowed'
                  //   : item2?.position_origin === 'BT'
                  //     ? 'bg-[#D7DB1A0D] hover:cursor-pointer'
                  //     : 'bg-[#0085FF1A] hover:cursor-pointer',
                  item2 == 0 || list_months[index2] == 'Anual'
                    ? 'cursor-not-allowed'
                    : typeof item2 != 'object'
                      ? 'cursor-not-allowed'
                      : item2?.position_origin === 'BT'
                        ? 'bg-[#D7DB1A0D] hover:cursor-pointer'
                        : 'bg-[#0085FF1A] hover:cursor-pointer',
                ]"
                class="whitespace-nowrap py-3 text-xs font-medium"
                @click="
                  () => {
                    if (item2 === 0 || list_months[index2] === 'Anual') {
                      return;
                    }
                    if (typeof item2 != 'object') {
                      return;
                    }
                    setPeriod({
                      year: year[index],
                      month: list_months[index2].toString().toUpperCase(),
                    });
                  }
                "
              >
                <span
                  v-if="typeof item2 === 'object' && Object.keys(item2).length > 0"
                  is="transition"
                  name="slide-fade"
                  mode="out-in"
                >
                  <span :key="index2">
                    {{ showPnl(item2.result) }}
                  </span>
                </span>
                <span v-else-if="typeof item2 === 'number'" is="transition" name="slide-fade" mode="out-in">
                  <span :key="index2">
                    {{ showPnl(item2) }}
                  </span>
                </span>
                <span v-else is="transition" name="slide-fade" mode="out-in">
                  <span :key="index2">-</span>
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <section class="legend mt-3 flex flex-col items-start justify-between md:flex-row">
      <div class="flex w-full flex-row justify-center space-x-6 py-3 md:justify-start md:py-0">
        <p class="inline-flex items-center space-x-1.5">
          <span class="block h-3 w-3 rounded-sm bg-[#B9AB3066]"></span>
          <span class="text-xs font-semibold">Backtest</span>
        </p>
        <p class="inline-flex items-center space-x-1.5">
          <span class="block h-3 w-3 rounded-sm bg-[#057BBF80]"></span>
          <span class="text-xs font-semibold">Paper trade</span>
        </p>
      </div>
      <div class="flex w-auto items-center space-x-2">
        <button @click="isOpenModalInfo = true">
          <svg class="w-4" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.00004 0.333313C3.32004 0.333313 0.333374 3.31998 0.333374 6.99998C0.333374 10.68 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.68 13.6667 6.99998C13.6667 3.31998 10.68 0.333313 7.00004 0.333313ZM7.66671 11.6666H6.33337V10.3333H7.66671V11.6666ZM9.04671 6.49998L8.44671 7.11331C7.96671 7.59998 7.66671 7.99998 7.66671 8.99998H6.33337V8.66665C6.33337 7.93331 6.63337 7.26665 7.11337 6.77998L7.94004 5.93998C8.18671 5.69998 8.33337 5.36665 8.33337 4.99998C8.33337 4.26665 7.73337 3.66665 7.00004 3.66665C6.26671 3.66665 5.66671 4.26665 5.66671 4.99998H4.33337C4.33337 3.52665 5.52671 2.33331 7.00004 2.33331C8.47337 2.33331 9.66671 3.52665 9.66671 4.99998C9.66671 5.58665 9.42671 6.11998 9.04671 6.49998Z"
              fill="#6C737F"
            />
          </svg>
        </button>
        <treeselect
          :multiple="false"
          :options="tableResultOptions"
          :show-count="true"
          :searchable="false"
          :clearable="false"
          placeholder="Selecionar"
          v-model="tableResultId"
          @select="tableResultSelect"
          class="h-9 w-full rounded-md md:w-72"
        >
          <div slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName" class="py-2">
            <div class="flex items-center justify-between" v-for="(item, index) in tableResultOptions" :key="index">
              <div class="space-x-3" v-if="node.id == item.id">
                <span class="text-sm text-gray-300">{{ node.label }}</span>
              </div>
            </div>
          </div>
          <div slot="value-label" slot-scope="{ node }" class="w-full">
            <div class="flex items-center justify-between" v-for="(item, index) in tableResultOptions" :key="index">
              <div class="space-x-3" v-if="node.id == item.id">
                <span class="text-sm text-gray-300">{{ node.label }}</span>
              </div>
            </div>
          </div>
        </treeselect>
      </div>
    </section>

    <portal to="modal">
      <ontick-modal-component :open="isOpenModalInfo" @close="isOpenModalInfo = false" size="small">
        <!-- <h1 class="text-2xl font-bold text-gray-50">Info</h1> -->
        <div class="divide-ontick-graphite-900 my-3 divide-y overflow-x-auto overflow-y-auto px-3">
          <div class="pb-4">
            <p class="text-sm font-medium">Retorno capital recomendado:</p>
            <p class="text-sm text-gray-400">Retorno (%) mensal baseado no capital mínimo recomendado.</p>
          </div>

          <div class="py-4">
            <p class="text-sm font-medium">Retorno acumulado:</p>
            <p class="text-sm text-gray-400">
              Retorno (%) acumulado. Usa como base de calculo o resultado do mês anterior.
            </p>
          </div>

          <div class="py-4">
            <p class="text-sm font-medium">Resultado em pontos:</p>
            <p class="text-sm text-gray-400">Resultado ($) mensal da estratégia convertido para pontos.</p>
          </div>

          <div class="py-4">
            <p class="text-sm font-medium">Resultado financeiro:</p>
            <p class="text-sm text-gray-400">Resultado ($) mensal da estratégia.</p>
          </div>

          <div class="py-4">
            <p class="text-sm font-medium">Volume operado:</p>
            <p class="text-sm text-gray-400">Quantidade de contratos ou ações operados pela estratégia no período.</p>
          </div>

          <div class="pt-4">
            <p class="text-sm font-medium">Número de operações:</p>
            <p class="text-sm text-gray-400">Quantidade de operações realizadas pela estratégia no período.</p>
          </div>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import OntickModalComponent from "../../../../shared/components/basic/ontick-modal.component.vue";
import EventBus from "@/app/shared/utils/event_bus.js";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "marketplaceCarousel",

  components: {
    OntickModalComponent,
    Treeselect,
  },

  props: {
    product: {
      type: Array,
      default: [],
    },
    pnlError: {
      type: String,
      default: "",
    },
    year: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      months: [],
      list_months: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez", "Anual"],
      tableResultId: "FIN_RESULT",
      tableResultOptions: [
        { label: "Retorno cap. recom. (%)", id: "REC_CAP_RET" },
        { label: "Retorno acumulado (%)", id: "CUM_RET" },
        { label: "Retorno em pontos", id: "POINTS_RESULT" },
        { label: "Resultado financeiro (R$)", id: "FIN_RESULT" },
        { label: "Volume operado", id: "VOLUME" },
        { label: "Número de operações", id: "OPERATION" },
      ],
      selectedPeriod: {
        periodYear: "ALL",
        periodMonth: "ALL",
      },
      isOpenModalInfo: false,
    };
  },

  created() {
    EventBus.$on("RESET_TABLE_PNL", () => {
      this.selectedPeriod = {
        periodYear: "ALL",
        periodMonth: "ALL",
      };
    });
  },

  watch: {
    product: {
      immediate: true,
      handler(values) {
        this.months = values;
        return values;
      },
    },
  },

  methods: {
    hasBorder(year, month) {
      const { periodYear, periodMonth } = this.selectedPeriod;
      return periodYear === year && periodMonth === month;
    },
    statusColor(value, { year, month }) {
      let color;

      if (!value) return "text-ontick-gray-500";

      if (value < 0) {
        color = "dark:text-ontick-red-600 text-ontick-red-900";
      } else if (value == 0) {
        color = "dark:text-gray-400 text-ontick-carbon-900";
      } else {
        color = " dark:text-ontick-green-600 text-ontick-green-800";
      }
      return this.hasBorder(year, month) ? `${color} border-2 border-ontick-blue-600` : color;
    },
    tableResultSelect(result) {
      this.tableResultId = result.id;
      this.$emit("change", {
        year: this.selectedPeriod.periodYear,
        month: this.selectedPeriod.periodMonth,
        tableResultPNL: result.id,
      });
    },
    setPeriod({ year, month }) {
      const isSame = this.selectedPeriod.periodYear === year && this.selectedPeriod.periodMonth === month;
      this.$emit("selectedPeriod", isSame ? { year: "ALL", month: "ALL" } : { year, month });
      this.selectedPeriod.periodYear = isSame ? "ALL" : year;
      this.selectedPeriod.periodMonth = isSame ? "ALL" : month;
    },
    money(amount) {
      return Number.parseFloat(amount).toLocaleString("pt-BR", {
        // style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    showPnl(result) {
      if (["REC_CAP_RET", "CUM_RET"].includes(this.tableResultId)) {
        return this.money(result) + "%";
      }
      if (["POINTS_RESULT", "VOLUME", "OPERATION"].includes(this.tableResultId)) {
        return result;
      }
      if (this.tableResultId === "FIN_RESULT") {
        return this.money(result);
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border-style: solid !important;
}
</style>
